import { ICommonState } from './model';

export const CommonInitState: ICommonState = {
  userInfo: null,
};
